module.exports = __webpack_public_path__ + "static/img/XPS_13_9350.a2ae47f6.png";